module.exports = __webpack_public_path__ + "img/zyyw.c3880891.jpg";